export default "__VITE_ASSET__036b7be5__"